/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase_EditInputs */

const vi_phase_edit = /** @type {(inputs: Phase_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa giai đoạn`)
};

/**

* @param {Phase_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const phase_edit = /** @type {((inputs?: Phase_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_phase_edit(inputs)
});